import Table from "/src/components/table";
import httpLogsService from "/src/features/administration/logs/services/httpLogsService";
import { formatDateWithoutSeconds } from "/src/utils/dateWithoutSeconds";

function UserHttpLogsTable({ userId }) {
    const cells = [
        { column: "Date", name: "requested_at", sort: true, show: (v) => formatDateWithoutSeconds(v, true) },
        { column: "Path", name: "path" },
        { column: "Method", name: "method", show: (v) => <span className={`http-method ${v}`}>{v}</span> },
        { column: "Status", name: "status_code", sort: true },
        { column: "Duration (ms)", name: "query_time", sort: true },
        { column: "IP", name: "ip_address" },
        { column: "Company", name: "company_name" },
    ];

    const filters = [
        { type: "input", placeholder: "Method", name: "method" },
        {
            type: "input",
            placeholder: "Status",
            name: "status_code",
        },
        { type: "input", placeholder: "Company", name: "company_id" },
    ];

    return (
        <Table
            name="user api log"
            cells={cells}
            api={(apiParams) => httpLogsService.getUserLogs(userId, { ...apiParams })}
            actions={[]}
            buttons={[]}
            filters={filters}
        />
    );
}

export default UserHttpLogsTable;
